import { ActeurIcon } from "@logora/parliament.icons.regular_icons";
import { formatActeurSansGroupe, formatCell, formatGroupeParlementaire } from "../formatters";

const columns = [
	{
		header: "Nom",
		accessorKey: "acteurRef",
		cell: (info) => formatActeurSansGroupe(formatCell(info)),
	},
	{
		header: "Groupe politique",
		accessorKey: "acteurRef.groupeParlementaire",
		accessorFn: (originalRow) => originalRow.acteurRef?.groupeParlementaire,
		cell: (info) => formatGroupeParlementaire(formatCell(info)),
		enableSorting: false,
	},
	{
		header: "Code grammaire",
		accessorKey: "codeGrammaire",
		isVisible: false,
		meta: {
			filter: {
				label: "Code grammaire",
				variant: "text",
				defaultValue: "PAROLE_GENERIQUE",
				showInFilterBar: false,
			},
		},
	},
];

export const participantDebatDataset = {
	key: "interventions",
	name: "Orateurs",
	columns: columns,
	include: ["acteurRef.groupeParlementaire", "acteurRef.mandatPrincipal"],
	distinct: "acteurRefUid",
	searchTable: "acteurRef",
	searchLanguage: "simple",
	icon: <ActeurIcon height={20} width={20} />,
	searchPlaceholder: "Chercher un participant...",
	rowRedirect: (item) => `/parliament/acteurs/${item.acteurRefUid}`,
};
